import { render, staticRenderFns } from "./AddOrEditSource.vue?vue&type=template&id=3a3ea632&scoped=true"
import script from "./AddOrEditSource.vue?vue&type=script&lang=js"
export * from "./AddOrEditSource.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditSource.vue?vue&type=style&index=0&id=3a3ea632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3ea632",
  null
  
)

export default component.exports